module.exports = __webpack_public_path__ + "static/Angular-Iphone-a8509941379d0ba5f377e65f87ed57fd.mp4";